import React, { useMemo } from "react";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import Logo from "../../Images/logo.png";
import { useAppDispatch } from "../../Store/hooks";
import { useNotifier } from "../../Core/Notifier";
import { useLoginMutation } from "../../Api/attoDeskApi";
import { useFormik } from "formik";
import { IAuth } from "../../Api/Interface/api.interface";
import { setEnableAuth } from "../../Store/Auth/AuthSlice";
import { useNavigate } from "react-router-dom";
import { Privileges } from "../../Core/Enum/enum";

const Login: React.FC = () => {
  // const navigate = useNavigate();
  // const authContext = useContext(AuthContext);

  // if (!authContext) {
  //   return null;
  // }

  // const { login } = authContext;

  // const handleLogin = () => {
  //   login();
  //   navigate("/dashboard");
  // };
  const dispatch = useAppDispatch();
  const { showErrorMessage } = useNotifier();
  const [login, { isLoading }] = useLoginMutation();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    onSubmit: async (values) => {
      try {
        const loginResponse = await login(values).unwrap();
        if (!loginResponse.status) {
          showErrorMessage(loginResponse.message);
        } else {
          const tokenData = loginResponse.data as IAuth;
          localStorage.setItem("token", tokenData.token);
          if (tokenData.lightThemeColor) {
            localStorage.setItem("lightThemeColor", JSON.stringify(tokenData.lightThemeColor));
          }
          if (tokenData.darkThemeColor) {
            localStorage.setItem("darkThemeColor", JSON.stringify(tokenData.darkThemeColor));
          }
          dispatch(setEnableAuth());
          navigateBasedOnPrivileges(loginResponse.privileges);
          window.location.reload();
        }
      } catch (error) {
        showErrorMessage("Please check you username or password");
      }

      // navigate('/dashboard');
    },
  });
  const formValid = useMemo(() => {
    return formik.values.username === "" || formik.values.password === ""
      ? false
      : true;
  }, [formik]);

  const navigateBasedOnPrivileges = (privileges: string[]) => {
    if (privileges.includes(Privileges.DashboardView)) {
      navigate("/dashboard");
    } else if (privileges.includes(Privileges.ClientView)) {
      navigate("/customer/list");
    } else if (privileges.includes(Privileges.PoliciesView)) {
      navigate("/policy-list");
    } else if (privileges.includes(Privileges.CoverageView)) {
      navigate("/policy-scenarios/list");
    } else if (privileges.includes(Privileges.PoliciesView)) {
      navigate("/policy/list");
    } else if (privileges.includes(Privileges.CoverageView)) {
      navigate("/category/list");
    } else if (privileges.includes(Privileges.InsuranceCompanyView)) {
      navigate("/brand/list");
    } else if (privileges.includes(Privileges.UserView)) {
      navigate("/user/list");
    } else if (privileges.includes(Privileges.UserRoleView)) {
      navigate("/user/role/list");
    }  else if (privileges.includes(Privileges.PrivilegeView)) {
      navigate("/user/privilege/list");
    } else if (privileges.includes(Privileges.BranchView)) {
      navigate("/branch/list");
    } else if (privileges.includes(Privileges.ThemeView)) {
      navigate("/theme-color");
    }  else if (privileges.includes(Privileges.StaffView)) {
      navigate("/team/list");
    } else if (privileges.includes(Privileges.DepartmentView)) {
      navigate("/department/list");
    } else if (privileges.includes(Privileges.PositionView)) {
      navigate("/position/list");
    } else if (privileges.includes(Privileges.ClientView)) {
      navigate("/client/meeting");
    } else if (privileges.includes(Privileges.ToDoView)) {
      navigate("/conversations/list");
    } else if (privileges.includes(Privileges.NewslettersView)) {
      navigate("/newsletters/list");
    } else if (privileges.includes(Privileges.ClientTypeView)) {
      navigate("/client_type/list");
    } else if (privileges.includes(Privileges.WorkshopView)) {
      navigate("/workshop/list");
    }
   
    // } else if (privileges.includes(Privileges.CategoriesView)) {
    //   navigate("/category/list");
    // } else if (privileges.includes(Privileges.LoopingView)) {
    //   navigate("/looping/list");
    
    // } else if (privileges.includes(Privileges.TaxView)) {
    //   navigate("/tax/list");
    // } else if (privileges.includes(Privileges.PrinterView)) {
    //   navigate("/printer/list");
    
   
    // } else if (privileges.includes(Privileges.ItemsView)) {
    //   navigate("/main/item/list");
    // } else if (privileges.includes(Privileges.ItemsView)) {
    //   navigate("/product/list");
    // } else if (privileges.includes(Privileges.TagView)) {
    //   navigate("/tag/list");
    // } else if (privileges.includes(Privileges.BranchView)) {
    //   navigate("/brand/list");
    
  
    // } else if (privileges.includes(Privileges.ScheduleView)) {
    //   navigate("/schedule/list");
    // } else if (privileges.includes(Privileges.ScheduleView)) {
    //   navigate("/Schedule/list/one-day");
    // } else if (privileges.includes(Privileges.PayrollView)) {
    //   navigate("/payroll/list");
    // } 
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box
        sx={{
          backgroundColor: "white",
          boxShadow: 3,
          p: 5,
          maxWidth: 500,
          height: "auto",
          mx: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            pb: 4,
          }}
        >
          <img
            src={Logo}
            alt="AttoDesk Login"
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        </Box>
        <TextField
          fullWidth
          variant="filled"
          label="Username"
          margin="normal"
          sx={{
            backgroundColor: "#FFFFFF",
            border: "1px solid #CCCCCC",
          }}
          {...formik.getFieldProps("username")}
        />
        <TextField
          fullWidth
          variant="filled"
          label="Password"
          type="password"
          margin="normal"
          sx={{
            backgroundColor: "#FFFFFF",
            border: "1px solid #CCCCCC",
          }}
          {...formik.getFieldProps("password")}
        />
        <Button
          variant="contained"
          disabled={!formValid || isLoading}
          type="submit"
          // onClick={handleLogin}
        >
          {isLoading && (
            <Box sx={{ pr: 2, pt: 0.5 }}>
              <CircularProgress size={16} sx={{ color: "white" }} />
            </Box>
          )}
          Login
        </Button>
      </Box>
    </form>
  );
};

export default React.memo(Login);
